import React from 'react';
import { redirectToCheckout } from '../../services/stripeService';

export default function UpgradePromptModal({ isOpen, onClose, user, feature }) {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  if (!isOpen) return null;

  const handleUpgrade = async () => {
    setLoading(true);
    setError(null);
    try {
      await redirectToCheckout(user.email, 'pro');
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  const features = {
    player: {
      title: 'Upgrade to Add More Players',
      message: 'Free users are limited to 1 player. Upgrade to Pro for unlimited players!',
    },
    season: {
      title: 'Upgrade to Add More Seasons',
      message: 'Free users are limited to 1 season. Upgrade to Pro for unlimited seasons!',
    },
    pro: {
      title: 'Track Club & School Seasons',
      message: 'Club season is here! Free users can only track 1 season at a time. Upgrade to Pro to track multiple seasons simultaneously—perfect for tracking both your club and school seasons in one place.',
    },
    tournaments: {
      title: 'Upgrade to Access Tournaments',
      message: 'Tournaments are a Pro feature. Upgrade now to track tournament performance!',
    },
    trends: {
      title: 'Upgrade to Access Trends',
      message: 'The Trends view is a Pro feature. Upgrade now to analyze your performance over time!',
    },
  };

  const content = features[feature] || features.player;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '500px',
          width: '100%',
          padding: '32px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginTop: 0, marginBottom: '16px', fontSize: '24px' }}>
          {content.title}
        </h2>
        <p style={{ marginBottom: '24px', color: '#666', lineHeight: '1.6' }}>
          {content.message}
        </p>

        <div
          style={{
            background: '#f8f9fa',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '24px',
          }}
        >
          <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px' }}>
            VballStats Pro includes:
          </div>
          <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>Unlimited Players</li>
            <li>Unlimited Seasons</li>
            <li>Tournament Support</li>
            <li>Trends View</li>
            <li>Priority Support</li>
          </ul>
          <div
            style={{
              marginTop: '16px',
              fontSize: '28px',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            $10<span style={{ fontSize: '16px', fontWeight: 'normal' }}>/year</span>
          </div>
        </div>

        {error && (
          <div
            style={{
              background: '#fee',
              color: '#c33',
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '16px',
              fontSize: '14px',
            }}
          >
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
          <button
            className="btn btn-primary"
            onClick={handleUpgrade}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Upgrade Now'}
          </button>
          <button
            className="btn btn-primary"
            onClick={onClose}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}